module.exports = __webpack_public_path__ + "img/122.276018bd.png";